/**
 * Stored original default themes for the project.
 * This allows restoring the original defaults even when DB values change.
 */
export const ORIGINAL_DEFAULT_THEMES = [
  {
    name: "Classic Green",
    colors: {
      textColor: "rgb(0, 179, 0)",
      backgroundColor: "",
      headerColor: "",
    },
  },
  {
    name: "Classic Red",
    colors: {
      textColor: "#ff0000",
      backgroundColor: "",
      headerColor: "",
    },
  },
  {
    name: "Pure Pink",
    colors: {
      textColor: "#000000",
      backgroundColor: "#ffc3de",
      headerColor: "#ffc3de",
    },
  },
  {
    name: "Modern Orange",
    colors: {
      textColor: "#000000",
      backgroundColor: "#ff7a38",
      headerColor: "#c2c2c2",
    },
  },
  {
    name: "Modern Red",
    colors: {
      textColor: "#000000",
      backgroundColor: "#dadada",
      headerColor: "#e6210c",
    },
  },
];

/**
 * Clear Themes is the first/base theme - always available
 * Other themes are fetched from Firebase using useDefaultThemesData() hook
 */
const CLEAR_THEME = {
  name: "Clear Themes",
  colors: {
    textColor: "",
    backgroundColor: "",
    headerColor: "",
  },
};

export default CLEAR_THEME;
